module.exports = __webpack_public_path__ + "img/ddcx.5029b673.png";